exports = module.exports = require("../../../../../../../employee/node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".owner-info-card {\n  margin-bottom: 10px;\n  margin-top: 5px;\n  padding-left: 0px !important;\n  padding-right: 0px !important; }\n\n.header-button-container {\n  display: -ms-flexbox;\n  display: flex; }\n\n@media only screen and (max-width: 768px) {\n  .header-button-container {\n    padding-top: 12px; }\n  .ownerinfo-header {\n    display: block !important; } }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!../lib/egov-ui-kit/common/propertyTax/Property/components/OwnerInfo/index.css
// module id = ./node_modules/css-loader/index.js?{"importLoaders":1}!./node_modules/postcss-loader/lib/index.js?{"ident":"postcss","plugins":[null,null]}!../lib/egov-ui-kit/common/propertyTax/Property/components/OwnerInfo/index.css
// module chunks = 504